

























import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { instanceOfIMultiSelectableConditionallyAsynchronously } from "../../system/selectors";
import { IMultiOrderableUserListSelectorDialogCondition, MultiOrderableUserListSelectorDialog } from "../../user/dialogs";
import { User } from "../../../domain/user";
import UserDetailViewer from "../../user/viewers/UserDetailViewer.vue";

@Component({
  components: {
    UserDetailViewer
  }
})
export default class ReceptionMultiDialogSelector extends Mixins(ModelEditableMixin) {
  editingSource: User[];

  // TODO ここMultiOrderableUserListSelectorDialogにして、validateの仕組み考えるか・・・
  @Prop()
  dialog: MultiOrderableUserListSelectorDialog;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop()
  condition: IMultiOrderableUserListSelectorDialogCondition;

  @Prop()
  toStyle: (s: User[]) => string;

  @Prop()
  requiredUsers: User[];

  @Prop()
  shouldShowPhoneNumber: boolean;

  data(): any {
    return {
      isVisible: false,
      isEditting: false,
      closeDelay: null,
      selectDelay: null,
      selectedUser: null
    };
  }
  isVisible: boolean;
  isEditting: boolean;
  closeDelay: NodeJS.Timer;
  selectDelay: NodeJS.Timer;
  selectedUser: User;

  get selectedValues(): User[] {
    return (!this.editingSource) ? [] : this.editingSource;
  }

  get isSelectable(): boolean {
    return !!this.dialog;
  }

  select(): void {
    this.selectOptions().then(o => {
      if (o !== undefined) {
        // undefinedの時はキャンセル.
        this.editingSource = o;
      }
    });
  }

  selectOptions(): Promise<User[]> {
    const condition = (instanceOfIMultiSelectableConditionallyAsynchronously<User, IMultiOrderableUserListSelectorDialogCondition>(this.dialog))
      ? this.condition
      : null;
    return this.dialog.selectOptionsRequiredConditionally(condition, this.editingSource, this.requiredUsers);
  }

  clear(): void {
    this.editingSource = [];
  }

  updateVisible(value: boolean): void {
    if (this.isEditting) {
      return;
    }
    if (!!this.closeDelay) {
      clearTimeout(this.closeDelay);
    }
    if (value) {
      if (!!this.selectDelay) {
        clearTimeout(this.selectDelay);
      }
      this.isVisible = true;
    } else {
      this.closeDelay = setTimeout(() => {
        this.isVisible = false;
        this.selectedUser = null;
      }, 1000);
    }
  }

  updateSelectedUser(value: User): void {
    if (this.isEditting) {
      return;
    }
    if (!!this.selectDelay) {
      clearTimeout(this.selectDelay);
    }
    this.selectDelay = setTimeout(() => {
      this.selectedUser = value;
    }, 200);
  }

  onEdittingChanged(value: boolean): void {
    this.isEditting = value;
  }

  toDisplayText(user: User): string {
    if (!user) { return ""; }
    return this.shouldShowPhoneNumber
      ? user.nameAndPhoneNumber
      : user.name;
  }
}
